import React from 'react'
import PropTypes from 'prop-types'
import {CircularProgress, Typography, withStyles} from '@material-ui/core'

const styles = {
    loader: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },

    loaderText: {
        marginTop: '0.5em'
    }
}

const Loader = function({classes: styles, isLoading, loaderText, size, marginTop}) {
    if (isLoading) {
        return (
            <div className={styles.loader} style={{marginTop}}>
                <CircularProgress color={'primary'} size={size} />
                {loaderText && <Typography className={styles.loaderText} variant="h6" color="primary">{loaderText}</Typography>}
            </div>
        )
    }
    return null
}

Loader.propTypes = {
    classes: PropTypes.object,
    isLoading: PropTypes.bool,
    loaderText: PropTypes.string,
    size: PropTypes.number,
    marginTop: PropTypes.string
}

Loader.defaultProps = {
    isLoading: false,
    marginTop: '10em',
    size: 50
}

export default withStyles(styles)(Loader)
